/**
 * Compose VPN/NAT tunnel rule payloads for the Parental Filter screen.
 * Merges: parental domain list + main Settings keywords/allow/category rules + optional advanced media keywords.
 */

import AsyncStorage from "@react-native-async-storage/async-storage";
import {
  normalizeCategoryRules,
  parseBlockListText,
  parseKeywordList,
} from "../utils/websiteBlockerCore";
import { mergeBlockedKeywordsWithAdvancedMedia } from "./advancedMediaKeywords";
import { getGoogleYoutubeSafeModeEnabled } from "./BlocklistManager";

const MAIN_SETTINGS_KEY = "settings";

async function loadMainSettingsSyncExtras() {
  try {
    const raw = await AsyncStorage.getItem(MAIN_SETTINGS_KEY);
    if (!raw) {
      return { allow: [], keywords: [], categoryRules: normalizeCategoryRules({}) };
    }
    const p = JSON.parse(raw);
    return {
      allow: parseBlockListText(p?.allowedSitesText || ""),
      keywords: parseKeywordList(p?.blockedKeywordsText || ""),
      categoryRules: normalizeCategoryRules(p?.categoryRules || {}),
    };
  } catch {
    return { allow: [], keywords: [], categoryRules: normalizeCategoryRules({}) };
  }
}

/**
 * @param {string[]} parentalDomains normalized host suffix blocklist from Parental panel
 * @param {boolean} advancedMediaKeywordsEnabled
 */
export async function buildParentalVpnSyncPayload(parentalDomains, advancedMediaKeywordsEnabled) {
  const [snippet, safeMode] = await Promise.all([
    loadMainSettingsSyncExtras(),
    getGoogleYoutubeSafeModeEnabled(),
  ]);
  const keywords = mergeBlockedKeywordsWithAdvancedMedia(snippet.keywords, advancedMediaKeywordsEnabled);
  return {
    block: Array.isArray(parentalDomains) ? parentalDomains : [],
    allow: snippet.allow,
    keywords,
    categoryRules: snippet.categoryRules,
    safeMode,
  };
}
